import { render, staticRenderFns } from "./Searches_mobile.vue?vue&type=template&id=45b4ed5f&"
import script from "./Searches_mobile.vue?vue&type=script&lang=js&"
export * from "./Searches_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Searches_mobile.vue?vue&type=style&index=0&id=45b4ed5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports